import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Header from "@/components/Header";
import PackagesSection from "@/components/PackagesSection";
import AddonsSection from "@/components/AddonsSection";
import PropertyManagementSection from "@/components/PropertyManagementSection";
import ConsultationForm from "@/components/ConsultationForm";
import ContactDetails from "@/components/ContactDetails";
import Footer from "@/components/Footer";

export default function RelocationPage() {
  return (
    <div className="App bg-white min-h-screen" data-testid="relocation-page">
      <Header />
      <main>
        {/* Page hero */}
        <section
          className="pt-36 pb-16 relative overflow-hidden"
          style={{
            background:
              "linear-gradient(180deg, #E8DCF3 0%, #FBF5F0 60%, #FFFFFF 100%)",
          }}
          data-testid="relocation-hero"
        >
          <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm text-[var(--gg-text-muted)] hover:text-[var(--gg-primary)] mb-8"
              data-testid="back-to-home"
            >
              <ArrowLeft size={16} /> Back home
            </Link>
            <div className="max-w-3xl">
              <span className="eyebrow">Relocation & Property</span>
              <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-[var(--gg-deep)] mt-5 leading-[1.02] font-semibold text-balance">
                A trusted path home,
                <br />
                <em className="not-italic text-[var(--gg-primary)] font-normal">
                  and eyes on the ground.
                </em>
              </h1>
              <p className="mt-7 text-lg text-[var(--gg-text)] leading-relaxed max-w-2xl">
                Three considered relocation tiers, an à la carte menu, and
                professional oversight of your Jamaican property while you build
                or live abroad.
              </p>
            </div>
          </div>
        </section>

        <PackagesSection />
        <AddonsSection />
        <PropertyManagementSection />

        {/* Cross link to senior care */}
        <section className="py-20 bg-[var(--gg-cream)]" data-testid="cross-link-care">
          <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
            <span className="eyebrow">Also from Graceful Guidance</span>
            <h2 className="font-serif text-3xl md:text-4xl text-[var(--gg-deep)] mt-4 font-semibold">
              Need in-home care as well?
            </h2>
            <p className="mt-4 text-[var(--gg-text)] max-w-2xl mx-auto">
              Once you&apos;re home, our in-home senior care team continues the
              journey — daily companionship, medical coordination, and safety.
            </p>
            <Link
              to="/senior-care"
              className="mt-8 inline-flex items-center gap-3 bg-[var(--gg-primary)] text-white hover:bg-[var(--gg-primary-dark)] transition-colors rounded-full pl-7 pr-3 py-3.5 text-sm"
              data-testid="link-to-care"
            >
              Explore Senior Care
              <span className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center">
                <ArrowRight size={16} />
              </span>
            </Link>
          </div>
        </section>

        <ConsultationForm />
        <ContactDetails />
      </main>
      <Footer />
    </div>
  );
}
